// Sample HIGO encounter payload (trimmed to ~2 files per multi-file exam
// for readability) used to preview visual-media vitals cards during
// development, via the dev-only "Load Mock Data" button in VitalsCheck.
// The first report's valueMeasurements are extra (not from a real HIGO
// encounter) — added purely to pad out the card count so the results
// grid's scroll behavior can be tested without a live session.
const higoEncounterMock = {
  higoEncounterId: "1264",
  status: "COMPLETED",
  startedAt: "2026-06-23T11:33:50.642395",
  completedAt: "2026-06-23T11:34:54.652483",
  examTypes:
    "HEART_AUSCULTATION_EXAM,LUNGS_AUSCULTATION_EXAM,COUGH_EXAM,ABDOMINAL_AUSCULTATION_EXAM,SKIN_EXAM,THROAT_EXAM,RIGHT_EAR_EXAM,LEFT_EAR_EXAM",
  reports: [
    {
      rawDeviceReadingId: 320,
      diagnosticReportId: "86345",
      createdAt: "2026-06-23T11:33:51.0",
      valueMeasurements: [
        { type: "VISUAL_ACUITY_LEFT", value: "1.3", unit: "", textValue: "" },
        { type: "VISUAL_ACUITY_RIGHT", value: "2", unit: "", textValue: "" },
        { type: "COLOR_BLINDNESS", value: "", unit: "", textValue: "Normal" },
        { type: "ECG", value: "88", unit: "bpm", textValue: "" },
        { type: "SYSTOLIC", value: "90", unit: "mmHg", textValue: "" },
        { type: "DIASTOLIC", value: "80", unit: "mmHg", textValue: "" },
        { type: "HEART_RATE", value: "72", unit: "bpm", textValue: "" },
        { type: "TEMPERATURE", value: "36.7", unit: "°C", textValue: "" },
        { type: "SPO2", value: "98", unit: "%", textValue: "" },
        { type: "GLUCOSE", value: "95", unit: "mg/dL", textValue: "" },
        { type: "WEIGHT", value: "70", unit: "kg", textValue: "" },
        { type: "HEIGHT", value: "175", unit: "cm", textValue: "" },
        { type: "BMI", value: "22.9", unit: "", textValue: "" },
      ],
      visualMeasurements: [],
    },
    {
      rawDeviceReadingId: 321,
      diagnosticReportId: "86346",
      createdAt: "2026-06-23T11:33:53.473016",
      valueMeasurements: [],
      visualMeasurements: [
        {
          id: 20,
          uuid: "6e2d7d86-af36-4c87-9d86-5b0790e65edb",
          measurementType: "HEART_AUSCULTATION_EXAM",
          deviceType: "higo",
          measurementDateTime: "2026-06-23T11:26:03",
          totalSourceFiles: 2,
          sourceFiles: [
            {
              id: 277,
              fileUrl:
                "https://storage.googleapis.com/drive.test.dentacarts.com/public/mt_develop/higo-media/0/22_higo_heart_auscultation_exam_2407109_000.mp3",
              contentType: "audio/mpeg",
              sequenceOrder: 0,
              createdAt: "2026-06-23T11:33:58.119083",
            },
            {
              id: 278,
              fileUrl:
                "https://storage.googleapis.com/drive.test.dentacarts.com/public/mt_develop/higo-media/0/22_higo_heart_auscultation_exam_2407110_001.mp3",
              contentType: "audio/mpeg",
              sequenceOrder: 1,
              createdAt: "2026-06-23T11:33:58.131486",
            },
          ],
        },
      ],
    },
    {
      rawDeviceReadingId: 322,
      diagnosticReportId: "86347",
      createdAt: "2026-06-23T11:33:59.22257",
      valueMeasurements: [],
      visualMeasurements: [
        {
          id: 21,
          uuid: "c20e78eb-b588-44fb-8747-78692991425b",
          measurementType: "LUNGS_AUSCULTATION_EXAM",
          deviceType: "higo",
          measurementDateTime: "2026-06-23T11:29:45",
          totalSourceFiles: 2,
          sourceFiles: [
            {
              id: 281,
              fileUrl:
                "https://storage.googleapis.com/drive.test.dentacarts.com/public/mt_develop/higo-media/0/22_higo_lungs_auscultation_exam_2407113_000.mp3",
              contentType: "audio/mpeg",
              sequenceOrder: 0,
              createdAt: "2026-06-23T11:34:10.491029",
            },
            {
              id: 282,
              fileUrl:
                "https://storage.googleapis.com/drive.test.dentacarts.com/public/mt_develop/higo-media/0/22_higo_lungs_auscultation_exam_2407114_001.mp3",
              contentType: "audio/mpeg",
              sequenceOrder: 1,
              createdAt: "2026-06-23T11:34:10.534325",
            },
          ],
        },
      ],
    },
    {
      rawDeviceReadingId: 323,
      diagnosticReportId: "86348",
      createdAt: "2026-06-23T11:34:12.114944",
      valueMeasurements: [],
      visualMeasurements: [
        {
          id: 22,
          uuid: "f08bad12-9391-4cc8-bbeb-12e55cc56244",
          measurementType: "COUGH_EXAM",
          deviceType: "higo",
          measurementDateTime: "2026-06-23T11:30:17",
          totalSourceFiles: 1,
          sourceFiles: [
            {
              id: 293,
              fileUrl:
                "https://storage.googleapis.com/drive.test.dentacarts.com/public/mt_develop/higo-media/0/22_higo_cough_exam_2407125_000.mp3",
              contentType: "audio/mpeg",
              sequenceOrder: 0,
              createdAt: "2026-06-23T11:34:13.834934",
            },
          ],
        },
      ],
    },
    {
      rawDeviceReadingId: 324,
      diagnosticReportId: "86350",
      createdAt: "2026-06-23T11:34:15.670005",
      valueMeasurements: [],
      visualMeasurements: [
        {
          id: 23,
          uuid: "dad878c3-ba50-46cd-92d4-3dbf6f1c9e60",
          measurementType: "ABDOMINAL_AUSCULTATION_EXAM",
          deviceType: "higo",
          measurementDateTime: "2026-06-23T11:32:14",
          totalSourceFiles: 2,
          sourceFiles: [
            {
              id: 294,
              fileUrl:
                "https://storage.googleapis.com/drive.test.dentacarts.com/public/mt_develop/higo-media/0/22_higo_abdominal_auscultation_exam_2407126_000.mp3",
              contentType: "audio/mpeg",
              sequenceOrder: 0,
              createdAt: "2026-06-23T11:34:21.486875",
            },
            {
              id: 295,
              fileUrl:
                "https://storage.googleapis.com/drive.test.dentacarts.com/public/mt_develop/higo-media/0/22_higo_abdominal_auscultation_exam_2407127_001.mp3",
              contentType: "audio/mpeg",
              sequenceOrder: 1,
              createdAt: "2026-06-23T11:34:21.525892",
            },
          ],
        },
      ],
    },
    {
      rawDeviceReadingId: 325,
      diagnosticReportId: "86351",
      createdAt: "2026-06-23T11:34:22.859315",
      valueMeasurements: [],
      visualMeasurements: [
        {
          id: 24,
          uuid: "7c5ff4f5-10f9-4aed-91ab-3c79621c9555",
          measurementType: "SKIN_EXAM",
          deviceType: "higo",
          measurementDateTime: "2026-06-23T11:32:35",
          totalSourceFiles: 2,
          sourceFiles: [
            {
              id: 296,
              fileUrl:
                "https://storage.googleapis.com/drive.test.dentacarts.com/public/mt_develop/higo-media/0/22_higo_skin_exam_2407128_000.gif",
              contentType: "image/gif",
              sequenceOrder: 0,
              createdAt: "2026-06-23T11:34:28.101041",
            },
            {
              id: 297,
              fileUrl:
                "https://storage.googleapis.com/drive.test.dentacarts.com/public/mt_develop/higo-media/0/22_higo_skin_exam_2407129_001.gif",
              contentType: "image/gif",
              sequenceOrder: 1,
              createdAt: "2026-06-23T11:34:28.123497",
            },
          ],
        },
      ],
    },
    {
      rawDeviceReadingId: 326,
      diagnosticReportId: "86352",
      createdAt: "2026-06-23T11:34:29.399263",
      valueMeasurements: [],
      visualMeasurements: [
        {
          id: 25,
          uuid: "a88269ee-be0f-497c-a4e4-fe875861c5f9",
          measurementType: "THROAT_EXAM",
          deviceType: "higo",
          measurementDateTime: "2026-06-23T11:32:53",
          totalSourceFiles: 2,
          sourceFiles: [
            {
              id: 304,
              fileUrl:
                "https://storage.googleapis.com/drive.test.dentacarts.com/public/mt_develop/higo-media/0/22_higo_throat_exam_2407136_000.gif",
              contentType: "image/gif",
              sequenceOrder: 0,
              createdAt: "2026-06-23T11:34:37.7368",
            },
            {
              id: 305,
              fileUrl:
                "https://storage.googleapis.com/drive.test.dentacarts.com/public/mt_develop/higo-media/0/22_higo_throat_exam_2407137_001.gif",
              contentType: "image/gif",
              sequenceOrder: 1,
              createdAt: "2026-06-23T11:34:37.810201",
            },
          ],
        },
      ],
    },
    {
      rawDeviceReadingId: 327,
      diagnosticReportId: "86353",
      createdAt: "2026-06-23T11:34:39.108929",
      valueMeasurements: [],
      visualMeasurements: [
        {
          id: 26,
          uuid: "a005a8b5-93b0-47ff-9917-5c1a031f9896",
          measurementType: "RIGHT_EAR_EXAM",
          deviceType: "higo",
          measurementDateTime: "2026-06-23T11:33:41",
          totalSourceFiles: 2,
          sourceFiles: [
            {
              id: 322,
              fileUrl:
                "https://storage.googleapis.com/drive.test.dentacarts.com/public/mt_develop/higo-media/0/22_higo_right_ear_exam_2407196_000.gif",
              contentType: "image/gif",
              sequenceOrder: 0,
              createdAt: "2026-06-23T11:34:46.476204",
            },
            {
              id: 323,
              fileUrl:
                "https://storage.googleapis.com/drive.test.dentacarts.com/public/mt_develop/higo-media/0/22_higo_right_ear_exam_2407197_001.gif",
              contentType: "image/gif",
              sequenceOrder: 1,
              createdAt: "2026-06-23T11:34:46.499744",
            },
          ],
        },
      ],
    },
    {
      rawDeviceReadingId: 328,
      diagnosticReportId: "86354",
      createdAt: "2026-06-23T11:34:48.089906",
      valueMeasurements: [],
      visualMeasurements: [
        {
          id: 27,
          uuid: "9842cef2-b1b9-44f7-98ce-fef164dba9e0",
          measurementType: "LEFT_EAR_EXAM",
          deviceType: "higo",
          measurementDateTime: "2026-06-23T11:33:47",
          totalSourceFiles: 2,
          sourceFiles: [
            {
              id: 336,
              fileUrl:
                "https://storage.googleapis.com/drive.test.dentacarts.com/public/mt_develop/higo-media/0/22_higo_left_ear_exam_2407210_000.gif",
              contentType: "image/gif",
              sequenceOrder: 0,
              createdAt: "2026-06-23T11:34:54.175305",
            },
            {
              id: 337,
              fileUrl:
                "https://storage.googleapis.com/drive.test.dentacarts.com/public/mt_develop/higo-media/0/22_higo_left_ear_exam_2407211_001.gif",
              contentType: "image/gif",
              sequenceOrder: 1,
              createdAt: "2026-06-23T11:34:54.194314",
            },
          ],
        },
      ],
    },
  ],
};

export default higoEncounterMock;
